import React, { useEffect, useMemo, useState } from "react";
import { connect, useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";

import GiftCategoryDialog from "../Components/Dialog/GiftCategoryDialog";
import { deleteGiftCategory, getGiftCategory } from "../store/GiftCategory/GiftCategory.action";
import { OPEN_CATEGORY_DIALOG } from "../store/GiftCategory/Giftcategory.type";
import { warning } from "../util/Alert";
import { baseURL } from "../util/config";
import { apiInstanceFetch } from "../util/api";
import { Chip, PageHead, Table, Tiles, fmt } from "./Panel/kit";

const cell = { padding: "6px 9px", border: "1px solid #E5E7EB", borderRadius: 6, fontSize: 13 };
const small = { fontSize: 12, color: "#6B7280" };

const thumb = (src) => (
  <div
    style={{
      width: 48,
      height: 48,
      borderRadius: 12,
      background: "#F3F4F6",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      overflow: "hidden",
    }}
  >
    {src ? <img src={src} alt="" style={{ width: 42, height: 42, objectFit: "contain" }} draggable="false" /> : "—"}
  </div>
);

/// Hediye kategorileri: her satirda kac hediye var, fiyat araligi ne.
const GiftCategory = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { giftCategory } = useSelector((state) => state.giftCategory);

  const [q, setQ] = useState("");
  // kategori basina hediye sayisi ve fiyat araligi
  const [stats, setStats] = useState({});

  useEffect(() => {
    dispatch(getGiftCategory());
  }, [dispatch]);

  useEffect(() => {
    apiInstanceFetch
      .get("gift")
      .then((res) => {
        const out = {};
        for (const c of res?.gift || []) {
          const coins = (c.gift || []).map((g) => Number(g.coin) || 0);
          out[String(c._id)] = {
            count: coins.length,
            min: coins.length ? Math.min(...coins) : 0,
            max: coins.length ? Math.max(...coins) : 0,
            svga: (c.gift || []).filter((g) => g.svga).length,
          };
        }
        setStats(out);
      })
      .catch(() => {});
  }, []);

  const rows = useMemo(() => {
    const list = Array.isArray(giftCategory) ? giftCategory : [];
    const needle = q.trim().toLowerCase();
    return list.filter((c) => !needle || String(c.name || "").toLowerCase().includes(needle));
  }, [giftCategory, q]);

  const openGift = (data) => {
    sessionStorage.removeItem("giftClick");
    sessionStorage.setItem("category", JSON.stringify(data));
    history.push("/admin/giftCategory/gift");
  };

  const handleDelete = (id) => {
    warning()
      .then((isDeleted) => {
        if (isDeleted) props.deleteGiftCategory(id);
      })
      .catch((err) => console.log(err));
  };

  const totalGifts = Object.values(stats).reduce((a, s) => a + s.count, 0);
  const passive = rows.filter((c) => c.isActive === false).length;

  return (
    <>
      <PageHead
        title="Hediye kategorileri"
        sub="Hediyeler kategoriler altında toplanır. Uygulamada hediye penceresindeki sekmeler bunlardır. Adında “şans/lucky” geçen kategori şanslı hediye olarak çalışır."
        right={
          <button className="btn btn-danger" onClick={() => dispatch({ type: OPEN_CATEGORY_DIALOG })}>
            Yeni kategori
          </button>
        }
      />

      <Tiles
        items={[
          { label: "Kategori", value: rows.length },
          { label: "Toplam hediye", value: fmt(totalGifts) },
          { label: "Kapalı kategori", value: passive },
        ]}
      />

      <div className="d-flex" style={{ gap: 8, marginBottom: 12 }}>
        <input
          style={{ ...cell, width: 260 }}
          placeholder="Kategori ara"
          value={q}
          onChange={(e) => setQ(e.target.value)}
        />
      </div>

      <Table
        head={["Görsel", "Kategori", "Hediye", "Fiyat aralığı", "Animasyonlu", "Durum", ""]}
        empty="Henüz kategori yok."
        rows={rows.map((c) => {
          const s = stats[String(c._id)] || { count: 0, min: 0, max: 0, svga: 0 };
          const lucky = /şans|sans|lucky/i.test(c.name || "");
          return (
            <tr key={c._id}>
              <td>{thumb(c.image ? baseURL + c.image : "")}</td>
              <td>
                <b>{c.name}</b>
                {lucky && (
                  <div style={{ marginTop: 3 }}>
                    <Chip kind="wait">Şanslı hediye</Chip>
                  </div>
                )}
              </td>
              <td>
                <b>{fmt(s.count)}</b>
              </td>
              <td style={small}>{s.count ? `${fmt(s.min)} – ${fmt(s.max)} coin` : "—"}</td>
              <td style={small}>{s.svga ? `${s.svga} SVGA` : "—"}</td>
              <td>{c.isActive === false ? <Chip kind="bad">Kapalı</Chip> : <Chip>Açık</Chip>}</td>
              <td style={{ whiteSpace: "nowrap" }}>
                <button className="btn btn-sm btn-primary" onClick={() => openGift(c)} style={{ marginRight: 6 }}>
                  Hediyeleri aç
                </button>
                <button
                  className="btn btn-sm btn-info"
                  onClick={() => dispatch({ type: OPEN_CATEGORY_DIALOG, payload: c })}
                  style={{ marginRight: 6 }}
                >
                  <i className="fas fa-edit text-white"></i>
                </button>
                <button className="btn btn-sm btn-danger" onClick={() => handleDelete(c._id)}>
                  <i className="fas fa-trash text-white"></i>
                </button>
              </td>
            </tr>
          );
        })}
      />

      <GiftCategoryDialog />
    </>
  );
};

export default connect(null, { getGiftCategory, deleteGiftCategory })(GiftCategory);
